import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "relative max-h-full overflow-y-auto scroll-hidden rounded-md"
};
const _hoisted_2 = {
  class: "custom-table"
};
const _hoisted_3 = {
  class: "relative shadow-container"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("table", _hoisted_2, [_createElementVNode("thead", null, [_renderSlot(_ctx.$slots, "header")]), _createElementVNode("tbody", _hoisted_3, [_renderSlot(_ctx.$slots, "default")])])]);
}